import React, { useState } from "react";
import { Button, Spinner, Text } from "@chakra-ui/react";
import { FaGoogle } from "react-icons/fa";
import { UserAuth } from "../contexts/AuthContext";

const GoogleSignInButton = ({ text, onRegisterAttempt }) => {
  const [loadingGoogle, setLoadingGoogle] = useState(false);
  const [firebaseError, setFirebaseError] = useState("");
  const { signInWithGoogle } = UserAuth();

  const handleSubmitGoogle = async () => {
    setFirebaseError("");
    setLoadingGoogle(true);

    try {
      await signInWithGoogle();
      setLoadingGoogle(false);
    } catch (e) {
      setLoadingGoogle(false);
      setFirebaseError(e.message);
    }
  };

  const handleClick = () => {
    if (onRegisterAttempt) {
      onRegisterAttempt();
    } else {
      handleSubmitGoogle();
    }
  };

  return (
    <div>
      {firebaseError && (
        <Text fontSize={"sm"} color="warning">
          {firebaseError}
        </Text>
      )}

      <Button
        width={"full"}
        mb={4}
        leftIcon={<FaGoogle />}
        variant={"outline"}
        onClick={handleClick}
        disabled={loadingGoogle}
      >
        {loadingGoogle ? <Spinner size="sm" /> : text}
      </Button>
    </div>
  );
};

export default GoogleSignInButton;
